import React from 'react';
import { StarIcon } from 'lucide-react';
import { CartButton } from './CartButton';
export function TopBar() {
  return <div className="sticky top-0 z-50 w-full bg-brand-black text-white py-3 px-4" data-id="element-275">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-6 flex-wrap text-sm md:text-base" data-id="element-276">
        <div className="flex items-center justify-center gap-6 flex-wrap flex-1" data-id="element-277">
          <span className="font-medium" data-id="element-278">
            Regrow Your Hair at Home — Without Drugs or Surgery
          </span>
          <div className="flex items-center gap-1" data-id="element-279">
            <span className="font-semibold" data-id="element-280">4.8</span>
            <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" aria-hidden="true" data-id="element-281" />
            <span className="text-gray-300 ml-1" data-id="element-282">Trusted by 75,000+ Men</span>
          </div>
        </div>
        <CartButton data-id="element-283" />
      </div>
    </div>;
}